<div class="ff-skeleton">
  <div *ngIf="showHeading" class="ff-skeleton__head">
    <app-skeleton className="h-16 md:h-22 w-220 r-4 c-post"></app-skeleton>
  </div>

  <div class="row">
    <div
      *ngFor="let _ of cardIndices"
      class="col-6 col-lg-4 d-flex"
    >
      <div class="ff-skeleton__card">
        <div class="ff-skeleton__avatar-ring">
          <app-skeleton className="h-80 w-80 r-50% c-post"></app-skeleton>
        </div>

        <div class="ff-skeleton__name">
          <app-skeleton className="h-18 w-120 r-4 c-post"></app-skeleton>
        </div>

        <div class="ff-skeleton__location">
          <app-skeleton className="h-14 w-120 r-4 c-post"></app-skeleton>
          <app-skeleton className="h-14 w-90 r-4 c-post"></app-skeleton>
        </div>

        <div class="ff-skeleton__btn-ring">
          <app-skeleton className="h-40 w-100% r-20 c-post"></app-skeleton>
        </div>
      </div>
    </div>
  </div>
</div>
